export default __webpack_public_path__ + "static/bg-86d55b77db33fa32b01a167dd5e9dcbc.png";